import { Box, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import classes from './CampaignCard.module.scss'
import { GivingCampaignOverviewDto } from '@percent/workplace-giving/api/campaigns/campaign.types'

export function CampaignCard({ id, title, coverImage, shortDescription }: GivingCampaignOverviewDto) {
  const { t } = useTranslation()

  return (
    <Link className={classes.Wrapper} data-testid="campaign-card" to={AppRoute.CAMPAIGN.replace(':campaignId', id)}>
      <Box className={classes.CoverImg} style={{ backgroundImage: `url(${coverImage})` }} />
      <Box className={classes.Content}>
        <Text className={classes.Title}>{title}</Text>
        <Text className={classes.Description}>{shortDescription}</Text>
        <Box className={classes.ActionsWrapper}>
          <Text className={classes.LearnMoreText}>{t('workplace_giving.common.learnMore')}</Text>
        </Box>
      </Box>
    </Link>
  )
}
